/* eslint-disable check-file/filename-blocklist -- pre-existing .jsx; this change only swaps an icon import, converting to .tsx is a separate migration */
import { IconButton } from '@/components/ats/IconButton';
import { FormBuilder } from '@/components/formBuilder';
import {
  Box,
  Button,
  Flex,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Text,
  useDisclosure,
} from '@chakra-ui/react';
import { useField } from 'formik';
import { useRef, useState } from 'react';
import moment from 'moment-timezone';
import { CalendarPlus01, CloseCircle, Edit05 } from '@kula-ai/icons-core';

const ScheduleBody = ({
  formConfig,
  handleFormSubmit,
  scheduleRef,
  onClose,
  dateWrapper,
  initialValues = {},
}) => {
  //eslint-disable-next-line
  const [meta] = useField('schedule_at');

  const initiateSchedule = () => {
    scheduleRef?.current.submitForm();
  };

  return (
    <Flex flexDir="column" gap="20px" p="10px">
      <FormBuilder
        config={formConfig}
        onSubmit={handleFormSubmit}
        formRef={scheduleRef}
        initialValues={initialValues}
      />

      <Flex alignSelf="end" gap="12px">
        <Button onClick={onClose} variant="ats-secondary">
          Cancel
        </Button>
        <Button
          onClick={initiateSchedule}
          disabled={!dateWrapper?.isFutureDate}
          variant="ats-primary"
        >
          Set schedule
        </Button>
      </Flex>
    </Flex>
  );
};

export const CustomScheduleAtV1 = () => {
  const [_field, meta, helpers] = useField('schedule_at');

  const { setValue } = helpers;

  const { isOpen, onClose, onToggle } = useDisclosure();
  const scheduleRef = useRef();

  const handleDateWrapperChange = (newDateWrapper) => {
    setDateWrapper(newDateWrapper);
  };

  const [dateWrapper, setDateWrapper] = useState({
    date: '',
    formattedTime: '',
    isFutureDate: false,
    time: '',
    timezoneValue: {},
  });

  const formConfig = [
    {
      name: 'schedule_at',
      type: 'dateWithTimeZone',
      enableTime: true,
      isInline: true,
      disablePreviousDate: true,
      returnWithTimeZoneFormat: true,
      customOnChange: handleDateWrapperChange,
    },
  ];

  const handleFormSubmit = (values) => {
    setValue(values?.schedule_at);
    onClose();
  };

  const formatScheduleDate = (dateString) => {
    // console.log(dateString, 'DTSTRING');
    try {
      const date = moment.parseZone(dateString);
      return `${date.format('DD MMMM YYYY, hh:mm A')} (GMT ${date.format(
        'Z'
      )})`;
    } catch {
      return 'Invalid Date';
    }
  };

  if (meta?.value?.formattedTime) {
    return (
      <Flex p="20px 0px" flexDir="column" gap="8px" width="100%">
        <Text size="sm-medium">Schedule</Text>
        <Box
          border="1px"
          borderColor="border-color"
          bgColor="ats-tertiary"
          borderRadius="md"
          p="10px"
        >
          <Text fontSize="sm">
            {formatScheduleDate(meta?.value?.formattedTime)}
          </Text>
        </Box>
        <Flex gap="12px" alignItems="center" mt="8px">
          <Popover
            isOpen={isOpen}
            onClose={onClose}
            placement="auto"
            strategy="fixed"
            closeOnBlur={true}
            closeOnEsc={true}
          >
            <PopoverTrigger>
              <Box>
                <IconButton
                  type="button"
                  text="Edit"
                  icon={Edit05}
                  iconContainerProps={{
                    width: 'unset',
                    height: 'unset',
                    bg: 'unset',
                  }}
                  iconProps={{
                    width: '14px',
                    height: '14px',
                  }}
                  gap="4px"
                  onClick={onToggle}
                />
              </Box>
            </PopoverTrigger>
            <PopoverContent>
              <PopoverBody>
                <ScheduleBody
                  formConfig={formConfig}
                  handleFormSubmit={handleFormSubmit}
                  onClose={onClose}
                  scheduleRef={scheduleRef}
                  initialValues={{ schedule_at: meta?.value }}
                  dateWrapper={dateWrapper}
                />
              </PopoverBody>
            </PopoverContent>
          </Popover>
          <IconButton
            text="Cancel"
            icon={CloseCircle}
            iconContainerProps={{
              width: 'unset',
              height: 'unset',
              bg: 'unset',
            }}
            iconProps={{
              width: '14px',
              height: '14px',
            }}
            gap="4px"
            onClick={() => {
              setValue(null);
            }}
          />
        </Flex>
      </Flex>
    );
  }

  return (
    <Flex p="20px 0px" flexDir="column" gap="8px">
      <Text size="sm-medium">Schedule</Text>
      <Popover
        isOpen={isOpen}
        onClose={onClose}
        placement="auto"
        strategy="fixed"
        closeOnBlur={true}
        closeOnEsc={true}
      >
        <PopoverTrigger>
          <Box>
            <IconButton
              type="button"
              text="Set schedule"
              onClick={onToggle}
              icon={CalendarPlus01}
            />
          </Box>
        </PopoverTrigger>
        <PopoverContent>
          <PopoverBody>
            <ScheduleBody
              formConfig={formConfig}
              handleFormSubmit={handleFormSubmit}
              onClose={onClose}
              scheduleRef={scheduleRef}
              dateWrapper={dateWrapper}
            />
          </PopoverBody>
        </PopoverContent>
      </Popover>
    </Flex>
  );
};
